import React from 'react';
import { MEEM_TOTAL_MAX } from '../../lib/meemItems';
import { lembretesEnabled } from '../../lib/flags';

const W = 280;
const H = 96;
const PAD = { l: 8, r: 8, t: 14, b: 22 };

function y(score) {
  const inner = H - PAD.t - PAD.b;
  return PAD.t + inner - (Math.max(0, Math.min(MEEM_TOTAL_MAX, score)) / MEEM_TOTAL_MAX) * inner;
}

/**
 * Prévia da evolução: o ponto de hoje e um ponto tracejado "sua próxima avaliação aparece aqui".
 * Só desenha o que já está na tela (o escore); nada é enviado nem gravado.
 */
export function EvolucaoPreview({ total }) {
  const x1 = 64;
  const x2 = W - 64;
  const y1 = y(total);
  const y2 = y1;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={`Prévia: pontuação de hoje, ${total} de ${MEEM_TOTAL_MAX}, e espaço para a próxima avaliação`} className="block h-auto w-full max-w-[320px]">
      <line x1={PAD.l} y1={H - PAD.b} x2={W - PAD.r} y2={H - PAD.b} stroke="var(--line)" strokeWidth="1" />
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="var(--ink-2)" strokeWidth="1.5" strokeDasharray="4 4" />
      <circle cx={x1} cy={y1} r="5" fill="var(--accent)" />
      <text x={x1} y={y1 - 9} textAnchor="middle" fontSize="12" fontWeight="600" fill="var(--ink)">{total}</text>
      <text x={x1} y={H - 6} textAnchor="middle" fontSize="11" fill="var(--ink-2)">hoje</text>
      <circle cx={x2} cy={y2} r="5" fill="var(--surface)" stroke="var(--ink-2)" strokeWidth="1.5" strokeDasharray="2 2" />
      <text x={x2} y={y2 - 9} textAnchor="middle" fontSize="12" fill="var(--ink-2)">?</text>
      <text x={x2} y={H - 6} textAnchor="middle" fontSize="11" fill="var(--ink-2)">próxima</text>
    </svg>
  );
}

/** Convite de conta como promessa de produto: o ganho (evolução), não a função (guardar). */
export default function EvolucaoCard({ total, onStart }) {
  return (
    <section aria-labelledby="evolucao-titulo" className="mt-4 rounded-[8px] border border-[var(--cell-border)] bg-[var(--surface)] p-4" data-evolucao-card>
      <h3 id="evolucao-titulo" className="font-sans text-[length:var(--fs-16)] font-semibold text-[var(--ink)]">
        O número de hoje só vale mais quando comparado ao próximo.
      </h3>
      <div className="mt-3 flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="sm:w-[44%]"><EvolucaoPreview total={total} /></div>
        <ul className="grid gap-1.5 text-[length:var(--fs-15)] leading-snug text-[var(--ink)] sm:flex-1">
          <li>Gráfico da pontuação de cada paciente ao longo do tempo</li>
          <li>Texto pronto para o prontuário, com a data</li>
          {lembretesEnabled() && <li>Aviso por e-mail na hora de reavaliar, no prazo que você escolher</li>}
          <li>A ficha de registro para imprimir</li>
        </ul>
      </div>
      <button type="button" onClick={onStart} data-analytics-event="calculator_evolucao_cta_clicked" className="btn-primary mt-4 w-full sm:w-auto">
        Criar conta grátis e acompanhar
      </button>
      <p className="mt-2 text-[length:var(--fs-14)] text-[var(--ink-2)]">Grátis, sem senha: enviamos um código de 6 dígitos ao seu e-mail.</p>
    </section>
  );
}
